import PageHeader from "../../components/pageHeader.jsx";
import IncomingPage from "../account_distribution/acc_incoming_page.jsx";
import {
  Link,
  Outlet,
  useNavigate,
  useLocation,
  useParams,
} from "react-router-dom";

export default function YoursPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();

  return (
    <>
      <div className="min-h-screen flex flex-col item-start p-4">
        <div>
          <div className="flex flex-row items-center px-4 py-2">
            <Link
              to="incoming"
              className={`font-bold px-4 pb-2 ${
                location.pathname === "/account_distribution/incoming"
                  ? "border-b-4 border-[#F7E21E] text-[#1E293B]"
                  : "text-gray-400 font-bold"
              }`}
            >
              Incoming Accounts
            </Link>
            <Link
              to="assigned"
              className={`font-bold px-4 pb-2 ${
                location.pathname === "/account_distribution/assigned"
                  ? "border-b-4 border-[#F7E21E] text-[#1E293B]"
                  : "text-gray-400 font-bold"
              }`}
            >
              Assigned Accounts
            </Link>
          </div>
          <Outlet />
        </div>
      </div>
    </>
  );
}
